import { TargetingPreviewDetails } from './TargetingPreviewDetails';

// Read-only card (C5-revive / Feature C) showing the FULL geo + audience picture
// kyck can interpret from the verbatim extracted targeting (rawPayload) — every
// included geo type named, excluded locations named, interests/age/gender/location
// types/advantage audience — plus the advanced Meta fields kyck preserves but
// doesn't render first-class. All of it applies at publish.
export function ExtractedTargetingSummary({
  rawPayload,
  campaignName,
  adSetName,
}: {
  rawPayload: unknown;
  campaignName: string | null;
  adSetName?: string | null;
}) {
  const source = [campaignName ?? 'a previous campaign', adSetName].filter(Boolean).join(' / ');

  return (
    <div className="space-y-3 rounded-md border border-kyck-200 bg-kyck-50/40 p-4">
      <p className="text-sm text-slate-600">
        Extracted from: <span className="font-medium text-slate-900">{source}</span>
      </p>
      <TargetingPreviewDetails rawPayload={rawPayload} />
    </div>
  );
}
